import Joi from "joi-browser";
import { CompletionStatus } from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Models/End";
import useConfigureForm from "../../../useConfigureForm";
import { defaultEndFormSchema } from "../../Default/useDefaultEndForm";

export default useWebhookNotificationForm;

export const webhookNotificationSchema = {
  ...defaultEndFormSchema,
  webhookList: Joi.array().min(1).required().label("Webhook")
};

export function getWebhookNotificationConfigureData(webhookNotification) {
  return {
    name: webhookNotification?.name ?? "",
    description: webhookNotification?.description ?? "",
    completionStatus:
      webhookNotification?.completionStatus ?? CompletionStatus.COMPLETED,
    webhookList: webhookNotification.webhookList ?? [],
  };
}

function useWebhookNotificationForm(
  webhookNotification,
  validationErrors = {},
) {
  const { formState, updateFormState, errors, validate } = useConfigureForm(
    () => getWebhookNotificationConfigureData(webhookNotification),
    webhookNotificationSchema,
    validationErrors,
  );

  return {
    formState,
    updateFormState,
    errors,
    validate,
  };
}
